module.exports = __webpack_public_path__ + "img/1893.089308f9.gif";